import PropTypes from 'prop-types';

export default PropTypes.shape({
  uic: PropTypes.string,
  shortCode: PropTypes.string,
  name: PropTypes.string
});
